export default function format(_ref) {
  let {
    alternativeName,
    mainCities,
    rawOffsetInMinutes,
    currentTimeOffsetInMinutes
  } = _ref;
  let {
    useCurrentOffset = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const offsetInHours = useCurrentOffset ? getOffsetString(currentTimeOffsetInMinutes) : getOffsetString(rawOffsetInMinutes);
  return "".concat(offsetInHours.padStart(6, "+"), " ").concat(alternativeName, " - ").concat(mainCities.join(", "));
}
function getOffsetString(offsetInMinutes) {
  const absOffsetInMinutes = Math.abs(offsetInMinutes);
  const [hours, minutes] = [Math.floor(absOffsetInMinutes / 60), absOffsetInMinutes % 60].map(v => {
    return v.toString().padStart(2, "0");
  });
  const durationInHoursMinutes = "".concat(hours, ":").concat(minutes);
  return "".concat(offsetInMinutes >= 0 ? "+" : "-").concat(durationInHoursMinutes);
}